import React, { useCallback, useState, useEffect } from "react";
import moment from "moment";
import SearchFormDatePickerButton from "./search_form_date_picker_button";

// hideDatePickerButton: 検索結果画面（search_form.jsx）では「別条件で検索する」モーダル側に
// 別日を選択ボタンを移設したため、ここでは非表示にする。ジャンル別ページ
// （search_form_for_main_genres.jsx）は今まで通りこのコンポーネント内に表示し続けるため、
// デフォルトはfalse（従来通り表示）のままにしている。
const SearchFormCalendar = ({ eventDate, eventDateFunc, hideDatePickerButton = false }) => {
  const [startDay, setStartDay] = useState(0);

  const DateOptionButton = useCallback(
    ({ index, isSelected = false, isFirstEl = false }) => {
      const momentObj = moment().add(index + startDay, "days");
      const btnColor = () => {
        if (momentObj.day() === 0) {
          return isSelected ? "text-danger bg-graydark" : "text-danger";
        } else if (momentObj.day() === 6) {
          return isSelected ? "text-primary bg-graydark" : "text-primary";
        } else {
          return isSelected ? "text-black bg-graydark" : "text-black";
        }
      };

      return (
        <button
          className={`btn-calendar ${btnColor()}`}
          onClick={() => eventDateFunc(momentObj.format("YYYY-MM-DD"))}
        >
          {index + startDay === 0 ? (
            <div className="btn-calendar__today">今日</div>
          ) : index + startDay === 1 ? (
            <div className="btn-calendar__tomorrow">明日</div>
          ) : (
            <div className="btn-calendar__week">
              {["日", "月", "火", "水", "木", "金", "土"][momentObj.day()]}
            </div>
          )}
          <div className="btn-calendar__date">{momentObj.format("M/D")}</div>
        </button>
      );
    },
    [eventDateFunc, startDay]
  );

  const [numOfDay, setNumOfDay] = useState(0);

    //親要素の幅を取得し、子要素がいくつ入るか算出
    useEffect(() => {
      const target = document.querySelector(".search-event__date").clientWidth;
      let count = Math.floor(target/62)//子要素の幅(58px)+左右マージン(2px+2px)
      setNumOfDay(count);
  }, );

  const DateOptionButtons = useCallback(
    () =>
      [...Array(11)].map((_, index) => (
        <DateOptionButton
          key={`dateoptionbutton_${index}`}
          index={index}
          isSelected={
            eventDate &&
            moment(eventDate).diff(moment().startOf("day"), "days") === index + startDay
          }
        />
      )),
    [eventDate, DateOptionButton]
  );

  return (
      <div className="search-event__day-choice">
        {!hideDatePickerButton && (
          <div className="search-event__another-day">
            <SearchFormDatePickerButton eventDate={eventDate} eventDateFunc={eventDateFunc} />
          </div>
        )}
        <div className="search-event__date-wrap">
          <div className="search-event__arrow is-left">
            {startDay > numOfDay - 1 ? (
              <button
                className="search-event__arrow-btn"
                onClick={() => setStartDay((prev) => prev - numOfDay)}
              >
                <svg
                  width="13"
                  height="20"
                  viewBox="0 0 13 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  >
                  <path
                    d="M12.12 2.12L4.24 10L12.12 17.88L10 20L-4.76837e-06 10L10 0L12.12 2.12Z"
                    fill="#FF6467"
                    fillOpacity="1"
                  />
                </svg>
              </button>
              ) : (
              <div className="search-event__arrow-btn">
                <svg
                  width="13"
                  height="20"
                  viewBox="0 0 13 20"
                  fillOpacity="0"
                  >
                </svg>
              </div>
              )}
          </div>
          <div className="search-event__date">
            <DateOptionButtons />
          </div>
          <div className="search-event__arrow is-right">
            <button
              className="search-event__arrow-btn"
              onClick={() => setStartDay((prev) => prev + numOfDay)}
            >
              <svg
                width="13"
                height="20"
                viewBox="0 0 13 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.880005 2.12L8.76 10L0.880005 17.88L3 20L13 10L3 0L0.880005 2.12Z"
                  fill="#FF6467"
                  fillOpacity="1"
                />
              </svg>
            </button>
          </div>
        </div>
        {/* <div className="mt-1">
          <DatePicker
            locale="ja"
            selected={eventDate && moment(eventDate).toDate()}
            minDate={new Date()}
            withPortal
            onChange={(date) => eventDateFunc(moment(date).format("YYYY-MM-DD"))}
            customInput={<DatePickerButton isFirstEl={true} />}
          />
        </div> */}
      </div>
  );
};

export default SearchFormCalendar;
